import { combineReducers } from 'redux';

import { SIGN_OUT } from 'constants/actionTypes';

import auth from './auth';
import popup from './popup';
import clubs from './clubs';
import teams from './teams';
import dialog from './dialog';
import toaster from './toaster';
import leaderboard from './leaderboard';
import avatars from './avatars';
import matches from './matches';

const reducers = {
  auth,
  popup,
  clubs,
  teams,
  dialog,
  toaster,
  leaderboard,
  avatars,
  matches,
};

const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
  // Clear all data in redux store to initial.
  if (action.type === SIGN_OUT) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
